<!--新建文件夹或修改名称 Sag 2020-4-16-->
<template>
  <ya-dialog-box :visible.sync="visible" :width=width multi-layer :fast-close="false" :father-action="dialogBoxAction" top="18%">
    <p slot="title">{{title ? title : '提示'}}</p>
    <div class="its-container">
      <p style="color: #333333">您还没有设置任教信息，无法分享资料给自己的学生</p>
      <p style="color: #666666">请联系您的学校管理员为您设置任教信息或联系<span style="color:#5591FE;">【400-900-2556】</span>帮助您设置</p>
    </div>
    <template slot="btn">
      <button class="ts-base-btn ts-primary-btn plain padding" @click="dialogAction()" >我知道了</button>
    </template>
  </ya-dialog-box>
</template>
<script>
import YaDialogBox from '../../../../components/YaDialogBox'
export default {
  name: 'CreateDialog',
  components: {
    YaDialogBox
  },
  props: {
    width: {
      type: String,
      default: '600px'
    },
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: 'create'
    },
    visible: {
      type: Boolean,
      default: false
    },
    canClick: {
      type: Boolean,
      default: true
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      fileName : '',
      title: ''
    }
  },
  methods: {
    dialogAction: function () {
      if (this.fatherAction) {
        this.fatherAction({type: 'close'})
      }
    },
    dialogBoxAction: function (action) {
      if (action.type === 'close') {
        this.dialogAction()
      }

    }
  }
}
</script>
<style scoped>
.its-title {
  vertical-align: middle;
}
.its-file-name{
  display: inline-block;
  width: 300px;
}

.its-container {
  text-align: center;
  padding: 20px 10px;
}

.its-container p {
  line-height: 30px;
  font-size: 14px;
}
</style>